export default function getUnexpectedErrors(errors, expectedErrors) {
    const unexpectedGraphQlErrors = errors.graphQlErrors.filter((error)=>!expectedErrors.includes(error.extensions.error.code));
    const isNetworkErrorExpected = expectedErrors.includes('network_error');
    if (unexpectedGraphQlErrors.length > 0 || // Client errors are always unexpected
    errors.clientErrors.length > 0 || errors.networkErrors.length > 0 && !isNetworkErrorExpected) {
        return {
            graphQlErrors: unexpectedGraphQlErrors,
            clientErrors: errors.clientErrors,
            networkErrors: errors.networkErrors
        };
    }
    return null;
}

//# sourceMappingURL=getUnexpectedErrors.js.map